<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
    <!-- <get-price :getPrice="getPrice" /> -->
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
// import getPrice from '@/component/categories/GetPriceSection'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import MotorInsuranceData from '@/data/company-page-data/bereket-sigorta/cross-pages/MotorInsurance'
export default {
  metaInfo: {
    title: 'Kasko Sigortası Fiyatları İçin Bereket Sigortadan Teklif Alın',
    meta: [
      {
        name: 'description',
        content: 'En ucuz kasko sorgulama ve Bereket Sigorta kasko fiyatları için online teklif aracımızdan faydalanabilir, poliçe tanzimi ile aracınıza güvence sağlayabilirsiniz'
      }
    ]
  },
  name: 'BereketSigortaMotorInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    // getPrice,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: MotorInsuranceData.headerContent,
      crossPageContent: MotorInsuranceData.crossPageContent,
      faqTitle: MotorInsuranceData.faqTitle,
      faqTitleDesc: MotorInsuranceData.faqTitleDesc,
      questions: MotorInsuranceData.questions
      // getPrice: MotorInsuranceData.getPrice
    }
  }
}
</script>
